// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Util_Css = require("../../util/Util_Css.bs.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Css = require("../particle/Particle_Css.bs.js");
var Particle_Color = require("../particle/Particle_Color.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Screen_Css = require("../particle/Particle_Screen_Css.bs.js");

function getTruncateLineRules(nbLine) {
  if (nbLine !== undefined) {
    return [
            CssJs.unsafe("WebkitBoxOrient", "vertical"),
            CssJs.overflow(CssJs.hidden),
            Util_Css.ieRules([CssJs.width(CssJs.pct(100))]),
            CssJs.unsafe("WebkitLineClamp", String(nbLine))
          ];
  } else {
    return [];
  }
}

function toCss(param) {
  var whiteSpace = param.whiteSpace;
  var alignment = param.alignment;
  var hover = param.hover;
  var sizeRules = Particle_Screen_Ds.map((function (s) {
          return Util_Array.pure(Particle_Css.font_size(s));
        }), param.size);
  var truncateLineRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Belt_Option.mapWithDefault(param.truncateLine, [], (function (param) {
              return Particle_Screen_Css.toRules(undefined, undefined, getTruncateLineRules, param);
            })));
  var wrapRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [whiteSpace !== undefined ? (
            whiteSpace ? CssJs.whiteSpace("preWrap") : CssJs.whiteSpace("nowrap")
          ) : CssJs.whiteSpace("normal")]);
  var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Util_Array.catOption([
            Caml_option.some(CssJs.color(Particle_Color.Css.color(param.color))),
            Caml_option.some(Particle_Css.font_family(param.family)),
            Caml_option.some(Particle_Css.font_weight(param.weight)),
            Caml_option.some(Particle_Css.line_height(param.lineHeight)),
            Belt_Option.map(param.decoration, Particle_Css.text_decoration),
            Belt_Option.map(param.style, Particle_Css.text_style),
            Caml_option.some(CssJs.hover(Particle_Css.text_hover(hover))),
            Caml_option.some(CssJs.focus(Particle_Css.text_hover(hover))),
            Caml_option.some(CssJs.marginBottom(CssJs.px(0)))
          ]));
  var alignmentRules = alignment !== undefined ? Particle_Screen_Ds.map((function (align) {
            return Util_Array.pure(Particle_Css.text_align(align));
          }), Caml_option.valFromOption(alignment)) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []);
  return Particle_Screen_Ds.$$Array.concat(wrapRules, Particle_Screen_Ds.$$Array.concat(truncateLineRules, Particle_Screen_Ds.$$Array.concat(alignmentRules, Particle_Screen_Ds.$$Array.concat(sizeRules, rules))));
}

exports.getTruncateLineRules = getTruncateLineRules;
exports.toCss = toCss;
/* CssJs Not a pure module */
